<template>
  <v-card outlined class="rounded-card ma-0">
    <v-row class="mx-3 pt-4 pb-4" align="center" justify="center">
      <v-col cols="9" align="start" class="pt-6">
        <strong style="font-size: 28px"> {{ localData.id }} </strong>
      </v-col>
      <v-col
        cols="2"
        :class="{
          activeMarker: true,
          online: localData.is_active,
          offline: !localData.is_active,
        }"
        class="pt-6"
        align="end"
      >
        <strong style="font-size: 18px">{{
          localData.is_active ? 'Activé' : 'Désactivé'
        }}</strong>
      </v-col>
      <v-col cols="1" class="pt-2">
        <v-switch
          class="switch-track"
          v-model="localData.is_active"
          rounded
          hide-details
          color="white"
        >
        </v-switch>
      </v-col>
    </v-row>

    <!-- SCENARIO NAME -->

    <v-row align="start" class="mx-4">
      <v-col cols="12" class="py-2">
        <strong class="scenario-text-title">Nom de votre campagne</strong>
      </v-col>
      <v-col cols="12" class="py-2">
        <v-text-field
          placeholder="Entrez un nom de campagne"
          outlined
          rounded
          hide-details=""
          v-model="localData.label"
          :rules="textFieldRules"
          :maxLength="maxLength"
        >
          <v-icon slot="append" color="green" class="mt-1"
            >check_circle_outline</v-icon
          >
        </v-text-field>
      </v-col>
    </v-row>

    <!-- SCENARIO TYPE -->

    <v-row align="start" class="mx-4">
      <v-col cols="6" class="pb-2 pt-2">
        <strong class="scenario-text-title">Type de campagne</strong>
      </v-col>
      <v-col cols="6" class="pb-2 pt-2">
        <strong class="scenario-text-title">Format du campagne</strong>
      </v-col>
    </v-row>

    <v-row class="mx-4" justify="center" align="center">
      <v-col cols="12" md="6">
        <v-btn-toggle class="toggle-btn" rounded style="width: 100%">
          <v-btn
            style="width: 50% !important"
            depressed
            @click="SwitchTriggerTypeAffluence()"
            :class="containerSwitchLeft2"
          >
            Affluence
          </v-btn>
          <v-btn
            style="width: 50% !important"
            depressed
            @click="SwitchTriggerTypeConsommation()"
            :class="containerSwitchLeft"
          >
            Consommation
          </v-btn>
          <!-- @click="containerSwitch()" -->
          <!-- :style="{ background: containerSwitch }" -->
        </v-btn-toggle>
      </v-col>
      <v-col cols="12" md="6">
        <v-btn-toggle class="toggle-btn" rounded style="width: 100%">
          <v-btn
            style="width: 50% !important"
            depressed
            :class="containerSwitchRight"
          >
            Envoyer SMS
          </v-btn>
          <v-btn
            style="width: 50% !important"
            depressed
            :class="containerSwitchRight2"
          >
            Envoyer Email
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <!-- CHIP SELECTION -->

    <v-col cols="3"></v-col>

    <v-row justify="center" class="mx-4">
      <v-col cols="12" class="pb-6">
        <strong class="scenario-text-title"
          >Choisissez la ou les tranches horaires fréquentées par la clientèle
          visée*</strong
        >
      </v-col>
    </v-row>
    <v-row class="pb-4 px-10">
      <v-col cols="12" align="center">
        <v-chip
          v-for="(segment, index) in enabledSegments"
          :key="index"
          class="chip-border mx-3 "
          :outlined="!segment.enabled"
          :color="segment.color"
          :class="{
            'pb-6 pr-2': $vuetify.breakpoint.md,
            'pr-3': $vuetify.breakpoint.lgAndUp,
          }"
          @click="toggleSegment(segment.code)"
        >
          <strong>{{ segment.title }}</strong>
        </v-chip>
      </v-col>
    </v-row>

    <!-- START AND END DATE SELECTION -->

    <!-- DATE PICKER CHOICE -->

    <v-row class="mx-4 mt-0 pt-0">
      <v-col cols="8">
        <strong class="scenario-text-title"
          >Choisissez les dates de début et de fin de la campagne</strong
        >
      </v-col>
    </v-row>

    <!-- CALENDAR -->
    <!-- 
    <v-row class="mx-4 pt-0">
        <div class="ml-2 mb-4"><v-btn rounded icon x-large color="#786ade" @click="addDate()"><v-icon>add_circle_outline</v-icon></v-btn><span @click="addDate()" style="color:#786ade">Ajouter une date</span></div>
    </v-row> -->

    <!-- <v-row class="mx-4 pt-0" v-for="(child, index) in children" :key="index"> -->

    <interval-picker v-model="scenarioDateInterval" class="pa-0 ml-2" />

    <!-- <v-col cols="auto" align="center">
            <div class="ml-2"><v-btn class="pb-6" rounded icon x-large color="#786ade" @click="removeInterval()"><v-icon>remove_circle_outline</v-icon></v-btn></div>
        </v-col> -->
    <!-- </v-row> -->

    <!-- TEXT AREAS -->

    <v-row class="mx-4 pt-0">
      <v-col cols="12">
        <strong class="scenario-text-title"> Votre message </strong>
      </v-col>
    </v-row>

    <v-row class="mx-4 pt-0">
      <TextEditorTipTap
        :value="localData.content"
        @input-raw="(v) => (localData.content = v)"
      />
    </v-row>

    <v-row class="mx-4 pt-0">
      <v-col cols="12" class="mb-4">
        <strong class="scenario-text-title"> Mentions légales </strong>
      </v-col>
    </v-row>

    <v-col cols="12" class="px-6">
      <v-textarea
        :rules="textFieldRules"
        v-on:input="$emit('input', $event)"
        placeholder="Ajoutez plusieurs lignes"
        v-model="localData.legal_content"
        outlined
        flat
        solo
        name="input-7-4"
        hide-details=""
        auto-grow
      ></v-textarea>
    </v-col>

    <!-- GROUP BUTTONS -->

    <v-row justify="center" class="pa-6">
      <v-col cols="3">
        <div class="text-center">
          <v-dialog
            class="theme-dialog"
            v-model="dialog"
            transition="dialog-bottom-transition"
            width="800px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                style="color: #6b5cd7"
                block
                v-bind="attrs"
                v-on="on"
                rounded
                outlined
              >
                Aperçu
              </v-btn>
            </template>

            <EmailPreview :scenario_preview="selectedScenario" />
          </v-dialog>
        </div>
      </v-col>
      <v-col cols="3">
        <customButton
          label="Enregistrer"
          btnType="save"
          btnForm
          @click="saveScenarioContentData()"
        />
      </v-col>
      <v-col cols="3">
        <customButton
          labelColor="purple-dark"
          label="Annuler"
          btnType="reset"
          btnForm
          @click="reset"
        />
      </v-col>
      <v-col cols="3">
        <customButton
          label="Supprimer"
          btnType="compare"
          btnForm
          @click="deleteScenario()"
        ></customButton>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import customButton from '@/components/buttons/customButton.vue';
import intervalPicker from './interval-picker.vue';
import TextEditorTipTap from './textarea-editor-tiptap.vue';
import EmailPreview from './v-card-email-preview.vue';

export default {
  components: {
    customButton,
    intervalPicker,
    TextEditorTipTap,
    EmailPreview,
  },
  data() {
    return {
      children: [],
      localData: {},
      calendar: false,
      calendar2: false,
      dialog: false,
      items: [],
      textFieldRules: [(v) => !!v || 'Merci de compléter les champs'],
      maxLength: 50,
    };
  },
  props: {
    triggerType: {
      type: String,
      default: '',
    },
  },
  computed: {
    selectedScenario() {
      return this.$store.state.scenarios.selectedScenario;
    },
    ref_segments() {
      return this.$store.state.scenarios.ref_segments;
    },
    enabledSegments() {
      if (!this.localData.hasOwnProperty('segments')) {
        return [];
      }

      let copy = JSON.parse(JSON.stringify(this.ref_segments));
      for (let i in copy) {
        copy[i].enabled = this.localData.segments.includes(copy[i].code);
      }
      return copy;
    },
    scenarioDateInterval: {
      get() {
        return {
          start_date: this.localData.start_date,
          end_date: this.localData.end_date,
        };
      },
      set(value) {
        // console.info('scenarioDateInterval', value);
        this.localData.start_date = value.start_date;
        this.localData.end_date = value.end_date;
      },
    },
    containerSwitchLeft() {
      if (this.selectedScenario.trigger_type === 'consommation') {
        return 'state-consommation';
      }
    },
    containerSwitchLeft2() {
      if (this.selectedScenario.trigger_type === 'affluence') {
        return 'state-affluence';
      }
    },
    containerSwitchRight() {
      if (this.selectedScenario.category === 'sms') {
        return 'state-sms';
      }
    },
    containerSwitchRight2() {
      if (this.selectedScenario.category === 'email') {
        return 'state-email';
      }
    },
  },
  created() {
    // console.log("created", this.selectedScenario);
    this.localData = JSON.parse(JSON.stringify(this.selectedScenario));
    this.localData.category = this.localData.category === 'AFFLUENCE' ? 0 : 1;
    this.localData.format = this.localData.format === 'SMS' ? 0 : 1;
  },
  methods: {
    addDate() {
      this.children.push({ startDate: null, endDate: null });
    },
    removeInterval() {
      this.children.splice(0, 1);
    },
    // updateScenarioContentData(field, value) {
    //   this.$store.commit("scenarios/setScenarioContentField", {
    //     field: field,
    //     value: value,
    //   });
    // },
    toggleSegment(segmentCode) {
      let segmentIndex = this.localData.segments.indexOf(segmentCode);
      let copy = [];

      if (segmentIndex > -1) {
        this.localData.segments.splice(segmentIndex, 1);
      } else {
        this.localData.segments.push(segmentCode);
      }
    },
    saveScenarioContentData() {
      this.$store.dispatch('scenarios/upsertScenarioContentById', {
        parameters: this.localData,
        success: () => {},
      });
      if (this.localData.content === null) {
        alert('Merci de composer un message');
      }
    },
    SwitchTriggerTypeAffluence() {
      // if(this.localData.trigger_type === "consommation") {
      //   this.localData.trigger_type = "affluence"
      // }
      // console.info('trigger_type', this.localData.trigger_type);
      // this.localData.trigger_type = !this.localData.trigger_type;
    },
    SwitchTriggerTypeConsommation() {
      // if(this.localData.trigger_type === "affluence") {
      //   this.localData.trigger_type = "consommation"
      // }
      // console.info('trigger_type', this.localData.trigger_type);
    },
    deleteScenario() {
      this.$store.dispatch('scenarios/deleteScenarioContentById', {});
    },
    reset() {
      window.location.reload();
    },
  },
};
</script>